define('views/search/search',[
  "globals",
  "backbone",
  "./advanced",
  "./results"
], function (globals, Backbone, AdvancedSearchView, SearchResultsView) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "submit form": "submit"
    },

    initialize: function (options) {
      this.options = options;

      this.model.on(
        "change:keywords change:offset change:type change:scope",
          this.render, this);

      if (_.has(this.options, "advancedEl")) {
        this.advancedView = new AdvancedSearchView({
          model: this.model,
          el: this.options.advancedEl
        });
      }

      globals.content.on("change:filter", this.model.resetDefaults);
    },

    submit: function (e) {
      e.preventDefault();

      var keywords = $.trim(this.$(":text").val());
      if (!keywords.length) return false;

      if (this.model.get("keywords") === keywords) {
        this.model.trigger("change:keywords");
      } else {
        this.model.set("keywords", keywords);
      }

      return this;
    },

    render: function () {
      if (!this.model.has("keywords")) return false;

      this.resultsView = this.resultsView || new SearchResultsView({
        el: this.options.resultsEl,
        model: this.model,
        $parentEl: this.$el
      });

      this.model.resetOffset().set("filter", globals.content.get("filter"));

      this.resultsView.toggleLoadingIndicator();

      this.collection.create(this.model.attributes, {
        success: this.resultsView.render
      });

      return this;
    }

  });
});

